import { ReactChild } from 'react'
import { useFeatureFlags } from '@opallabs/api'
import { Tooltip } from '@opallabs/lapidary'

export const InactiveUserTip = ({ children }: { children: ReactChild }) => {
  const { workspaces } = useFeatureFlags().data ?? { workspaces: false }

  return (
    <Tooltip
      content={
        workspaces
          ? 'This user is no longer a member of this workspace or has been deactivated.'
          : 'This user is no longer active.'
      }
    >
      {children}
    </Tooltip>
  )
}
